var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeeplinkFillingFastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9363_4535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4303 42.466C33.048 42.466 42.466 33.048 42.466 21.4303C42.466 9.81255 33.048 0.394531 21.4303 0.394531C9.81257 0.394531 0.394531 9.81255 0.394531 21.4303C0.394531 33.048 9.81257 42.466 21.4303 42.466Z",
    stroke: "white",
    strokeWidth: 0.655488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5794 21.3945C42.5794 33.0155 33.1646 42.4303 21.5436 42.4303C9.92254 42.4303 0.507812 33.0155 0.507812 21.3945",
    stroke: "white",
    strokeWidth: 0.655488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9545 21.3945C34.9545 28.7932 28.9443 34.8034 21.5455 34.8034C14.1469 34.8034 8.13672 28.7932 8.13672 21.3945",
    stroke: "white",
    strokeWidth: 0.655488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2364 21.3945C28.2364 25.1034 25.2314 28.1084 21.5225 28.1084C17.8136 28.1084 14.8086 25.1034 14.8086 21.3945",
    fill: "#C1F700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5697 0.394531H1.40021C0.874988 0.394531 0.449219 0.820301 0.449219 1.34551V41.515C0.449219 42.0403 0.874988 42.466 1.40021 42.466H41.5697C42.0949 42.466 42.5207 42.0403 42.5207 41.515V1.34551C42.5207 0.820301 42.0949 0.394531 41.5697 0.394531Z",
    stroke: "white",
    strokeWidth: 0.655488,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9363_4535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 42.8689,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeeplinkFillingFastIcon);
export default __webpack_public_path__ + "static/media/deeplink-filling-fast-icon.af4cec5ddb65bf0bd810656a0b818113.svg";
export { ForwardRef as ReactComponent };